import { ApplicationRef, Injectable, Injector, ViewContainerRef, Type, ComponentFactoryResolver, EmbeddedViewRef } from '@angular/core';
import { AcompanhamentoMeusComponent } from './acompanhamento-meus/acompanhamento-meus.component';

@Injectable({
  providedIn: 'root'
})
export class AcompanhamentoMeusService {

  private tempo = 0;

  private _componente: AcompanhamentoMeusComponent | null = null;
  
  public get componente(): Promise<AcompanhamentoMeusComponent> {
    return new Promise((async (resolve, reject) => {
      await this.carregarComponente(resolve, reject); 
    }));
  }

  async carregarComponente(resolve: any, reject: any) {
    if(!this._componente) {
      setTimeout(() => {
        this.tempo += 100;

        if(this.tempo > 2000) {
          reject();
          throw new Error("Componente não setado.");
        }

        this.carregarComponente(resolve, reject);
      }, 100);

      return;
    }

    resolve(this._componente);
  }

  constructor() {}

  public setarComponente(val: AcompanhamentoMeusComponent) {
    this._componente = val;
  }

  async abrir() {
    let c = await this.componente;
    c.abrirTelaCheia();
  }
}


